import React from "react";
import { Container } from "../../../../components";
import { Text, Heading } from "@telia/teddy";
import "./B2BReceiptCard.less";

const B2BReceiptCard: React.FC<{ email: string }> = ({ email }) => {
    return (
        <Container className="b2b-order__section b2b-receipt-card" size="large" whiteBg>
            <Heading mb="100" as="h2" variant="title-200">
                {"Bestilling gjennomført!"}
            </Heading>
            <Text mb="100" className="b2b-receipt-card__paragraph" data-di-mask>
                En e-post med ordrebekreftelse har blitt sendt til {email}.
            </Text>
        </Container>
    );
};

export default B2BReceiptCard;
